module.exports = __webpack_public_path__ + "images/bg_boatyard_img.4504021f672a63c375a54d9111159d6d.jpg";